import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { AlertTriangle } from 'lucide-react';
import type * as React from 'react';

const stripStyle = css`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	margin: 0;
	padding: 0.625rem 0.875rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.states.warning.surface};
	color: ${theme.states.warning.ink};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
`;

/** Heads a card whose interview was deleted while its recording was being sent from this device. */
type Props = {
	readonly isNotes: boolean;
};

const OrphanedInterviewStrip: React.FC<Props> = ({ isNotes }) => {
	return (
		<p css={stripStyle}>
			<AlertTriangle size={16} aria-hidden="true" />
			<span>
				{isNotes
					? "Attention, cette prise de notes a été supprimée. Ouvrez l'envoi pour choisir quoi faire de ses données."
					: "Attention, cet entretien a été supprimé. Ouvrez l'envoi pour choisir quoi faire de ses données."}
			</span>
		</p>
	);
};

export default OrphanedInterviewStrip;
